var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { createContext, useContext, useState, } from 'react';
var NurseryContext = createContext(undefined);
// Hook for functional components
export var useNurseryContext = function () {
    var context = useContext(NurseryContext);
    if (!context) {
        throw new Error('useNurseryContext must be used within NurseryProvider');
    }
    return context;
};
// HOC wrapper for class components
export var withNurseryContext = function (Component) {
    var WrappedComponent = React.forwardRef(function (props, ref) {
        var nurseryContext = useNurseryContext();
        return React.createElement(Component, __assign({}, props, nurseryContext, { ref: ref }));
    });
    WrappedComponent.displayName = "withNurseryContext(".concat(Component.displayName || Component.name, ")");
    return WrappedComponent;
};
// Provider
export var NurseryProvider = function (_a) {
    var children = _a.children;
    var _b = useState(''), nurseryName = _b[0], setNurseryName = _b[1];
    var _c = useState(''), nurserySlug = _c[0], setNurserySlug = _c[1];
    var isNursery = !!(nurseryName || nurserySlug);
    return (React.createElement(NurseryContext.Provider, { value: {
            nurseryName: nurseryName,
            nurserySlug: nurserySlug,
            setNurseryName: setNurseryName,
            setNurserySlug: setNurserySlug,
            isNursery: isNursery,
        } }, children));
};
